export default __webpack_public_path__ + "static/media/109.166e061f.webp";